import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import ButtonYesno from "../../../components/buttons/button.yesno";
import SelectCommon from "../../../components/selects/select.common";
import DmtgMain from "../../dmtg/DmtgMain";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Donation de parts de société non cotée
// Id simulateur 57, A2-11bis
// simulateurs associés : réserve d'usufruit et dmtg immo

function Simulateur_57(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [simulateurForDMTG, setSimulateurForDMTG] = useState({
    id: 109,
    name: "DMTG - Donation de biens immobiliers 1 à 9 personnes",
  });

  const [reserve_usufruit, setUsufruit] = useState(0);
  const [age_usufruitier_1, setAgeUsufruit1] = useState(0);
  const [age_usufruitier_2, setAgeUsufruit2] = useState(0);
  const [departement, setDepartement] = useState(0);
  const [nombre_donateurs, setDonateur] = useState(1);
  const [montant_donateur_1, setDonateur1] = useState(0);
  const [montant_donateur_2, setDonateur2] = useState(0);
  const [reversion_usufruit, setReversUsufruit] = useState(0);
  const [DMTG, setDMTG] = useState(0);
  const [responseDMTG, setResponseDMTG] = useState(null);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          reserve_usufruit: parseInt(reserve_usufruit),
          age_usufruitier_1: parseInt(age_usufruitier_1),
          age_usufruitier_2: parseInt(age_usufruitier_2),
          nombre_donateurs: parseInt(nombre_donateurs),
          montant_donateur_1: parseInt(montant_donateur_1),
          montant_donateur_2: parseInt(montant_donateur_2),
          reversion_usufruit: parseInt(reversion_usufruit),
          DMTG: parseInt(DMTG),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),

        },
        DMTG: responseDMTG,
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
      };
      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }
      
      if (setter === setUsufruit) {
        Object.assign(object["inputs"], { reserve_usufruit: parseInt(value) });
      }

      if (setter === setAgeUsufruit1) {
        Object.assign(object["inputs"], { age_usufruitier_1: parseInt(value) });
      }

      if (setter === setAgeUsufruit2) {
        Object.assign(object["inputs"], { age_usufruitier_2: parseInt(value) });
      }

      if (setter === setDonateur) {
        Object.assign(object["inputs"], { nombre_donateurs: parseInt(value) });
        if (parseInt(value) === 1) {
          setAgeUsufruit2(0);
          setDonateur2(0);
          Object.assign(object["inputs"], {
            age_usufruitier_2: 0,
            montant_donateur_2: 0,
          });
        }
      }

      if (setter === setDonateur1) {
        Object.assign(object["inputs"], { montant_donateur_1: parseInt(value) });
      }

      if (setter === setDonateur2) {
        Object.assign(object["inputs"], { montant_donateur_2: parseInt(value) });
      }

      if (setter === setReversUsufruit) {
        Object.assign(object["inputs"], { reversion_usufruit: parseInt(value) });
      }

      if (setter === setDMTG) {
        if (value === 0) {
          setResponseDMTG([]);
          Object.assign(object["inputs"], { DMTG: parseInt(value) });
          object.DMTG = [];
        } else {
          Object.assign(object["inputs"], { DMTG: parseInt(value) });
        }
      }

      if (setter === setResponseDMTG) {
        Object.assign(object["inputs"], { result: 1 });
        object.DMTG = value;
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  const nbDonateurs = [
    {
      id: 1,
      name: "Un donateur",
    },
    {
      id: 2,
      name: "Deux donateurs",
    },
  ];

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        {props.article && <p style={styles.cardSubTitle}>Acte tarifé au titre du Tableau 5, n° {props.article.slice(6, props.article.length)}</p>}

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Combien y a-t-il de donateurs ?</div>
          <SelectCommon
            items={nbDonateurs}
            defaultValue={1}
            nameField={"name"}
            optionValue={"id"}
            handleChange={handleChange}
            setter={setDonateur}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Est-ce une donation avec réserve d'usufruit ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setUsufruit} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {parseInt(reserve_usufruit) === 1 ? (
          <div style={styles.cardRowChild}>
            {
              <div className="cardRow">
                {nombre_donateurs == 2 ? (
                  <div style={styles.cardElemVerticalyCenter}>Indiquer l'âge du donateur 1 :</div>
                ) : (
                  <div style={styles.cardElemVerticalyCenter}>Indiquer l'âge du donateur :</div>
                )}
                <TextfieldNumber
                  handleChange={handleChange}
                  type={"number"}
                  placeholder={"Indiquer l'age"}
                  setter={setAgeUsufruit1}
                />
              </div>
            }

            {parseInt(nombre_donateurs) === 2 ? (
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>Indiquer l'âge du donateur 2 :</div>
                <TextfieldNumber
                  handleChange={handleChange}
                  type={"number"}
                  placeholder={"Indiquer l'age"}
                  setter={setAgeUsufruit2}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          {nombre_donateurs == 2 ? (
            <div style={styles.cardElemVerticalyCenter}>
              Quelle est la valeur en pleine propriété des titres transmis par le donateur 1 ?
            </div>
          ) : (
            <div style={styles.cardElemVerticalyCenter}>Quelle est la valeur en pleine propriété des titres transmis ?</div>
          )}
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setDonateur1}
          />
        </div>

        {parseInt(nombre_donateurs) === 2 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Quelle est la valeur en pleine propriété des titres transmis par le donateur 2 ?
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setDonateur2}
            />
          </div>
        ) : (
          <></>
        )}

        {parseInt(reserve_usufruit) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Y a-t-il une clause de réversion d’usufruit ?</div>
            <div>
              <ButtonYesno
                handleChange={handleChange}
                setter={setReversUsufruit}
                fieldUndefined={false}
                defaultValue={0}
              />
            </div>
          </div>
        ) : (
          <></>
        )}

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Souhaitez-vous faire le calcul des DMTG ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDMTG} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {DMTG ? (
          <DmtgMain
            callSinceSimu={true}
            simulateur={simulateurForDMTG}
            setter={setResponseDMTG}
            donateurs={parseInt(nombre_donateurs)}
            handleChange={handleChange}
            calculateDMTGState={props.calculateDMTGState}
          />
        ) : (
          <></>
        )}

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_57;
